import { createContext } from "react";
const iconContext = createContext({
  getIconSrc: name => void 0
});
export { iconContext as default };